import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '@/api/client';

export type PermissionName = 'Punches' | 'Shifts' | 'Monthly bills' | 'Leave days' | 'Policies';
export type PermissionsMap = Partial<Record<PermissionName, boolean>>;

const PermissionsCtx = createContext<PermissionsMap>({});

export const PermissionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [perms, setPerms] = useState<PermissionsMap>({});
  useEffect(() => {
    api.get('/User/GetUserPermissions').then(({ data }) => {
      const map: PermissionsMap = {};
      (data?.Permissions || []).forEach((p: any) => (map[p.permissionName as PermissionName] = !!p.allowed));
      setPerms(map);
    }).catch(() => setPerms({}));
  }, []);
  return <PermissionsCtx.Provider value={perms}>{children}</PermissionsCtx.Provider>;
};

export const usePermissions = () => useContext(PermissionsCtx);
export const can = (perms: PermissionsMap, key: PermissionName) => !!perms[key];
